import { Box } from 'grommet'
import styled from 'styled-components'

const darkButtonHoverColor = (props) => props.theme.global.colors['darkButtonHover']
const darkColor = (props) => props.theme.global.colors['dark-2']
const lightColor = (props) => props.theme.global.colors['white']
const disabledButtonColor = (props) => props.theme.global.colors['silverGrey']
const cancelButtonTextColor = "#2E6B9E"

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
`

export const SubmitButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 292px;
  height: 48px;
  border: none;
  border-radius: 4px;
  background-color: ${({buttonDisabled}) => buttonDisabled ? disabledButtonColor : darkColor};
  outline: none;
  font-family: 'Roboto';
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  color: ${({buttonDisabled}) => buttonDisabled ? 'black' : lightColor};
  cursor: ${({buttonDisabled}) => buttonDisabled ? 'not-allowed' : 'pointer'};

  :hover {
    background-color: ${({buttonDisabled}) => buttonDisabled ? disabledButtonColor : darkButtonHoverColor};
  }

  @media screen and (max-width: 485px) {
    width: 100%;
  }
`

export const CancelButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  border: none;
  border-radius: 4px;
  background-color: transparent;
  outline: none;
  font-family: 'Roboto';
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: ${cancelButtonTextColor};
  letter-spacing: 0.25px;
  text-decoration-line: underline;
  margin-top: 12px;
  cursor: pointer;
`
